import { render, staticRenderFns } from "./ReCardTaskHelp.vue?vue&type=template&id=80a24dae&scoped=true"
import script from "./ReCardTaskHelp.vue?vue&type=script&lang=js"
export * from "./ReCardTaskHelp.vue?vue&type=script&lang=js"
import style0 from "./ReCardTaskHelp.vue?vue&type=style&index=0&id=80a24dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a24dae",
  null
  
)

export default component.exports